<div class="quick-top-up-page page-section">
    <div class="header-part">
        <h1>Quick Top-Up</h1>
    </div>
    <div class="info-banner">
        <div class="flex">
            <img src="assets/icon/banner-success-icon.svg" width="32" height="32" alt="Success Icon">
            <div class="banner-content">
                <p class="smaller desc-a">Your FreeUP mobile number has been verified!</p>
                <p class="smaller desc-b last">Top-Up will be added to <b>{{phoneNumber}}</b></p>
            </div>
        </div>
    </div>
    <div class="form-box">
        <p class="smaller"><b>2. Enter Voucher number/PIN:</b></p>
        <form [formGroup]="voucherForm" (ngSubmit)="submitQuickTopUp()">
            <div class="form-field">
                <label class="outlined-label-input">
                    <input id="voucherNumber" type="tel" formControlName="voucherNumber" restrictNumbers placeholder=" "
                        minlength="12" maxlength="16" autocomplete="off" (paste)="onPaste($event)" />
                    <span>Voucher Number</span>
                </label>
                <label class="validation-message" id="required-voucher-msg"
                    *ngIf="voucherForm.controls.voucherNumber.touched && !voucherForm.controls.voucherNumber.value">
                    Voucher number is required</label>
                <label class="validation-message" id="invalid-voucher-msg"
                    *ngIf="!voucherForm.controls.voucherNumber.valid && !!voucherForm.controls.voucherNumber.value">
                    Voucher number is invalid</label>
            </div>
            <div class="form-field last">
                <label class="outlined-label-input">
                    <input id="confirmVoucherNumber" type="tel" formControlName="confirmVoucherNumber" restrictNumbers
                        placeholder=" " minlength="12" maxlength="16" autocomplete="off" (paste)="onPaste($event)" />
                    <span>Confirm Voucher Number</span>
                </label>
                <label class="validation-message" id="required-confirm-voucher-msg"
                    *ngIf="voucherForm.controls.confirmVoucherNumber.touched && !voucherForm.controls.confirmVoucherNumber.value">
                    Voucher number confirmation is required</label>
                <label class="validation-message" id="invalid-confirm-voucher-msg"
                    *ngIf="voucherForm.controls.confirmVoucherNumber.touched && !!voucherForm.controls.confirmVoucherNumber.value && voucherForm.hasError('mismatchedVoucherNumber')">
                    Voucher numbers do not match</label>
            </div>
            <div class="form-actions">
                <button class="button secondary" id="back-button" (click)="backPreviousPage()">Back</button>
                <button class="button primary" type="submit" id="submit-button">Submit</button>
            </div>
        </form>
    </div>
</div>